import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { Action } from 'src/app/core-module/models/Compliance-Actions/action';
import { BasicUser } from 'src/app/core-module/models/basic-user';

@Component({
  selector: 'app-action-summary-card',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, TagModule, DatePickerModule, SelectModule],
  templateUrl: './action-summary-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-summary-card.component.scss'
})
export class ActionSummaryCardComponent implements OnInit, OnChanges {
  @Input() action: Action = new Action();
  @Input() users: BasicUser[] = [];
  @Input() editing: boolean = false;
  @Input() validationError: string = '';
  @Input() descriptionError: string = '';
  @Input() assigneeError: string = '';
  @Input() dateError: string = '';
  @Output() updateAssignee = new EventEmitter<BasicUser>();
  @Output() updateDeadline = new EventEmitter<Date>();
  @Output() toggleResolved = new EventEmitter<void>();
  @Output() editDescription = new EventEmitter<void>();
  @Output() toggleEdit = new EventEmitter<void>();

  selectedUser: BasicUser | null = null;
  minDate: Date = this.startOfToday();

  ngOnInit(): void {
    this.setSelectedUser();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['users'] || changes['action']){
      this.setSelectedUser();
      this.setMinDate();
    }
  }

  onAssigneeChange(user: BasicUser){
    this.selectedUser = user;
    this.updateAssignee.emit(user);
  }

  onDeadlineChange(date: any){
    const value = Array.isArray(date) ? date[0] : date;
    if (value instanceof Date){
      this.updateDeadline.emit(value);
    }
  }

  statusSeverity(): 'success' | 'danger' | 'warn' | 'info'{
    if (this.action.Resolved){ return 'success'; }
    const today = this.stripTime(new Date());
    const due = this.stripTime(this.action.ActionDeadline);
    if (due < today){ return 'danger'; }
    if (due.getTime() === today.getTime()){ return 'warn'; }
    return 'info';
  }

  statusLabel(): string{
    if (this.action.Resolved){ return 'Resolved'; }
    const today = this.stripTime(new Date());
    const due = this.stripTime(this.action.ActionDeadline);
    if (due < today){ return 'Overdue'; }
    if (due.getTime() === today.getTime()){ return 'Due Today'; }
    return 'Open';
  }

  private setSelectedUser(){
    if (this.action.ActionOwnerID && this.users?.length){
      const match = this.users.find(u => u.UserID === this.action.ActionOwnerID && u.UserTypeID === this.action.ActionOwnerTypeID);
      if (match){
        this.selectedUser = match;
        return;
      }
    }
    if (this.action.ActionAssignee){
      const match = this.users.find(u => u.DisplayName === this.action.ActionAssignee);
      if (match){
        this.selectedUser = match;
      }
    }
  }

  private stripTime(d: Date): Date{
    const copy = new Date(d);
    copy.setHours(0,0,0,0);
    return copy;
  }

  private startOfToday(): Date {
    const d = new Date();
    d.setHours(0,0,0,0);
    return d;
  }

  private setMinDate(){
    const today = this.startOfToday();
    if (this.action?.ActionDeadline){
      const due = this.stripTime(new Date(this.action.ActionDeadline));
      this.minDate = due < today ? due : today;
    }else{
      this.minDate = today;
    }
  }
}
